export const PC_PREFIX = '/pc'
export const ADMIN_PREFIX = '/admin'
export const ADMIN_PAGE_LINKS = {
  adminOrderList: '/admin/orders',
  adminOrderDetail: '/admin/orders/detail',
  adminCouponList: '/admin/coupons',
  adminCouponEdit: '/admin/coupons/edit',
  adminCouponDetail: '/admin/coupons/detail',
  adminCouponCreate: '/admin/coupons/create',
}

export const PC_PAGE_LINKS = {
  // PC 端官网
  pcHome: `${PC_PREFIX}/`,
  pcGoodsDetail: `${PC_PREFIX}/goods_detail`,
  pcSearch: `${PC_PREFIX}/search`,
  pcJBAI: `${PC_PREFIX}/ai`,
  pcMyOrders: `${PC_PREFIX}/my-orders`,
  pcMyPurchased: `${PC_PREFIX}/my-purchased`,
  pcMyCoupons: `${PC_PREFIX}/my-coupons`,
  pcCoupon: `${PC_PREFIX}/coupon`,
  pcCouponCenter: `${PC_PREFIX}/coupon-center`,

  // 管理端
  admin: `${ADMIN_PREFIX}`,
  adminLogin: `${ADMIN_PREFIX}/login`,
  adminWorkbench: `${ADMIN_PREFIX}/workbench`,
  adminCourseList: `${ADMIN_PREFIX}/course/list`,
  adminCourseCreate: `${ADMIN_PREFIX}/course/create`,
  adminSeriesCourseList: `${ADMIN_PREFIX}/series_course/list`,
  adminSeriesCourseCreate: `${ADMIN_PREFIX}/series_course/create`,
  adminSeriesCourseDetail: `${ADMIN_PREFIX}/series_course/detail`,
  adminSpecialSeriesCourseList: `${ADMIN_PREFIX}/special_series_course/list`,
  adminSpecialSeriesCourseCreate: `${ADMIN_PREFIX}/special_series_course/create`,
  adminSpecialSeriesCourseDetail: `${ADMIN_PREFIX}/special_series_course/detail`,
  adminCourseAttr: `${ADMIN_PREFIX}/course_attr`,
  adminOrderList: `${ADMIN_PREFIX}/OrderListPage`,
  adminOrderDetail: `${ADMIN_PREFIX}/OrderDetailPage`,
  adminCouponList: `${ADMIN_PREFIX}/CouponManage`,
  adminCouponEdit: `${ADMIN_PREFIX}/CouponManage/EditPage`,
  adminCouponDetail: `${ADMIN_PREFIX}/CouponManage/DetailPage`,
  adminCouponCreate: `${ADMIN_PREFIX}/CouponManage/CreatePage`,
  adminPermission: `${ADMIN_PREFIX}/permission`,
  adminUserManage: `${ADMIN_PREFIX}/user_manage`,
  adminFrontUserManage: `${ADMIN_PREFIX}/front_user_manage`,
  adminFrontUserDetail: `${ADMIN_PREFIX}/front_user_manage/detail`,
}

export const MOBILE_PAGE_LINKS = {
  home: '/',
  search: '/search',
  goodsDetail: '/goods_detail',
  buyRecommend: '/buy_recommend',
  wxPay: '/wx_pay',
  wxLogin: '/wx_login',
  mobileOrder: '/mobile/order',
  personalCenter: '/mobile/personal/center',
  mobilePurshed: '/mobile/purchased',
  mobileCoupons: '/mobile/coupons',
  mobileCouponClaim: '/mobile/coupon_claim',
  mobileCouponCenter: '/mobile/coupon-center',
}

export type PAGE_LINKS_TYPE = typeof PC_PAGE_LINKS & typeof MOBILE_PAGE_LINKS

export const PAGE_LINKS = {
  ...PC_PAGE_LINKS,
  ...MOBILE_PAGE_LINKS,
} as PAGE_LINKS_TYPE

export const GOODS_FQA = [
  {
    title: '课件可以用于参赛吗？',
    content:
      '答：允许校内日常课、公开课场景使用，不可用于校级以上比赛及线上赛课。原创作品未经授权不可用作线上公开收益或免费引流使用',
  },
  {
    title: '课件可以导入希沃吗?',
    content:
      '答:课件使用Microsoft office 365或WPS office制作，可导入希沃使用，但由于是不同软件系统，会存在部分动画不兼容的问题，与课件本身无关。',
  },
  {
    title: '购买后可以退换吗?',
    content: '答:每个课件都有视频或图片预览，购买前请仔细查看课件内容，虚拟产品，一经购买，不退不换。',
  },
  {
    title: '课件购买后怎么下载?',
    content:
      '答:购买全套、单册/专题、单个课件，可直接点击课件进行下载课件资源。\n*文件较大，且包含字体，为保证预览效果，建议在电脑使用win解压压缩包，安装字体后再打开PPT',
  },
  {
    title: '除了课件，还包含教学设计和逐字稿吗?',
    content:
      '答:小、初、高语文类课件都包含教学设计，其他部分科目包含教学设计暂不包含逐字稿，课程详情页有预览说明、也可添加客服咨询。',
  },
  {
    title: '课件更新或教材改动后要重新购买吗?',
    content: '答:购买的课件在有效期内有更新或者改动是无需重新购买的，详情可添加官方客服了解。',
  },
  {
    title: '课件是否接受定制或修改?',
    content:
      '答:课件支持老师们个人编辑修改，不包含定制权益，如需定制课件，我们有专属定制团队可提供该服务、详情可添加官方客服了解。',
  },
  {
    title: '购买课件之后可以开发票吗?',
    content:
      '答:购买了课件可以联系官方客服开具发票。\n*可开票类别包括:信息服务费、文化订阅费、软件开发、教辅资料(详情可咨询官方客服)\n开票周期:5个工作日内',
  },
  {
    title: '课件的预览视频可以发送给我吗?',
    content: '答:视频仅做课件完整预览展示用，不在出售范围',
  },
  {
    title: '如果我对课件有更好的建议，该如何反馈?',
    content: '答:关于课程设计/动画设计方面，您可以联系客服提出您的想法，我们会酌情采取并进行修改。',
  },
]

export const customerServiceLinks = {
  default: 'https://work.weixin.qq.com/ca/cawcde1fdeb6f279f9?customer_channel=qywx_ca:110116543', // 自然流量
  ad: 'https://work.weixin.qq.com/ca/cawcde4637e31bc272?customer_channel=qywx_ca:109455889', // 广告
}
